import { SpaceProps } from 'styled-system';
import { StyledLoader } from './Loader.styles';
export const Loader: React.FC<{ size?: number } & SpaceProps> = ({ size = 32, ...rest }) => {
	const baseSize = 32;
	const targetScale = size / baseSize;
	return <StyledLoader scale={targetScale} {...rest} />;
};
